export enum ElectronicClientRecordLocationResultOption {
  Success = 'Success',
  Failed = 'Failed',
}
